// src/plugins/formatters.ts
import { App } from 'vue';

export default {
  install(app: App) {
    app.config.globalProperties.$dateFormat = (date: string): string => {
      const fecha = new Date(date.slice(0, 10) + ' 00:00:00');
      const dias_semana = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
      const hoy = new Date(
        new Date().toLocaleString('sv-SE', { timeZone: 'America/Monterrey' }).slice(0, 10)
      );
      const difference =
        (Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()) -
          Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())) /
        (1000 * 60 * 60 * 24);
      const meses = [
        'ene', 'feb', 'mar', 'abr', 'may', 'jun',
        'jul', 'ago', 'sep', 'oct', 'nov', 'dic'
      ];

      if (fecha.getUTCFullYear() !== new Date().getUTCFullYear()) {
        return `${dias_semana[fecha.getDay()]}, ${fecha.getDate()} de ${meses[fecha.getMonth()]}`;
      } else {
        return `${dias_semana[fecha.getDay()]}, ${fecha.getDate()} de ${meses[fecha.getMonth()]} de ${fecha.getUTCFullYear()}`;
      }
    };

    app.config.globalProperties.$hourFormat = (hour: string): string => {
      const hourInt = parseInt(hour.slice(0, 2));
      if (hourInt > 12) {
        return `${hourInt - 12}${hour.slice(2, 5)} P.M.`;
      } else {
        return `${hour.slice(0, 5)} A.M.`;
      }
    };
  }
};
